var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display"},[_c('p',{staticClass:"display-title"},[_vm._v("基本信息")]),_c('div',{staticClass:"display-middle"},[_c('icon-unit',{attrs:{"titleKey":"机构名称","titleValue":_vm.hospitalTitle,"iconKey":"机构Logo","iconURL":_vm.hospitalLogo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }